import { showToast } from 'vant'
import { bridge } from '~~/assets/js/dsbridge.js'
import eventJson from '~~/assets/js/webview_event.js'

type callFn = <P extends unknown[], R>(...params: P) => R
export type I$bt = {
  register: (key: string, fn: () => void) => void
  call: { [key in keyof typeof call]: callFn }
  callNative: (key: string, eventName: string, params: any, callback: () => void) => void
}

declare module '#app' {
  interface NuxtApp {
    $bt: I$bt
    $checkNetwork: () => boolean
  }
}
interface IWindow extends Window {
  bt: I$bt
}
const bt = (window as unknown as IWindow).bt || { register: {}, call: {} }

const { call } = eventJson

/**
 * 统一生成调用Native函数
 */
Object.entries(call).forEach(([key, val]) => {
  bt.call[key] = (params = {}, callback: () => void) => {
    const eventName = val.event_name
    return bt.callNative(key, eventName, params, callback)
  }
})

/**
 * 调用native API
 */
bt.callNative = function (key, name, params, callback) {
  if (!name) return
  // 浅拷贝会影响原对象
  // if (Object.keys(params).length > 0) {
  //   params = Object.assign(eventJson.call[key].message, params)
  // }
  if (typeof callback === 'function') {
    return bridge.call(name, params, callback)
  }
  return bridge.call(name, params)
}

/**
 * 注册H5 API
 */
bt.register = (eventName: string, bindFun: () => void) => {
  if (!eventName || typeof bindFun !== 'function') return
  bridge.register(eventName, bindFun)
}

export default defineNuxtPlugin((nuxtApp) => {
  const checkNetwork = (toast = true) => {
    const result = bt.call.getNetworkState<null[], { hasNetwork: boolean }>()
    let hasNetwork = true
    if (result) {
      hasNetwork = result.hasNetwork
    }
    if (!hasNetwork && toast) {
      showToast((nuxtApp.$i18n as object as { t: (str: string) => string }).t('no_network'))
    }
    return hasNetwork
  }
  return {
    provide: {
      bt,
      checkNetwork,
    },
  }
})
